module.exports = __webpack_public_path__ + "static/q7-734ff8dada7573dca3b65d0ca583f7ed.png";